<div
    class="nav-panel"
    [ngClass]="{'nav-panel--sticky': stickyMode}"
    #element
>
    <div class="nav-panel__container container">
        <div class="nav-panel__row">
            <div *ngIf="logo" class="nav-panel__logo">
                <a [routerLink]="root.home()">
                    <app-brand-logo class="nav-panel__brand"></app-brand-logo>
                </a>
            </div>

            <div *ngIf="departments" class="nav-panel__departments" style="max-width: 270px;">
                <app-header-departments></app-header-departments>
            </div>

            <!-- .nav-links -->
            <app-header-links class="nav-panel__nav-links nav-links"></app-header-links>
            <!-- .nav-links / end -->

            <div class="nav-panel__indicators">
                <app-indicator
                    *ngIf="search"
                    icon="search-20"
                    iconWhenOpen="cross-20"
                    trigger="click"
                    (stateChanges)="$event === true ? search.inputElement.focus() : ''"
                    #indicator="appIndicator"
                >
                    <app-search location="indicator" (escape)="indicator.close()" #search="search"></app-search>
                </app-indicator>

                <app-indicator [link]="root.wishlist()" icon="heart-20" [counter]="wishlist.count$|async" [title]="'wishlist' | t:'Wishlist'" [attr.title]="'wishlist' | t:'Wishlist'"></app-indicator>

                <app-indicator 
                    [title]="'shopping-cart' | t:'Shopping Cart'" [attr.title]="'shopping-cart' | t:'Shopping Cart'"
                    icon="cart-20"
                    trigger="hover"
                    [counter]="cart.quantity$|async"
                    (buttonClick)="onCartClick()"
                    #indicator="appIndicator">
                    <app-header-dropcart
                        *ngIf="dropcartType == 'dropdown'"
                        (closeMenu)="indicator.close(true)"
                    ></app-header-dropcart>
                </app-indicator>

                <!-- <app-indicator
                    link="./account/compare"
                    icon="compare-16"
                    trigger="hover"
                    [counter]="compare.quantity$|async"
                    (buttonClick)="onCartClick()"
                    #indicator="appIndicator">

                    <app-header-dropcart *ngIf="dropcartType == 'dropdown'"
                        (closeMenu)="indicator.close(true)">
                    </app-header-dropcart>
                </app-indicator> -->

                <app-indicator link="./account" icon="person-20" trigger="click" #indicator="appIndicator" [title]="'account-menu' | t:'Account Menu'" [attr.title]="'account-menu' | t:'Account Menu'"
                               (stateChanges)="accountMenu.opened($event)">
                    <app-account-menu #accountMenu (closeMenu)="indicator.close(true)"></app-account-menu>
                </app-indicator>
            </div>
        </div>
    </div>
</div>
